import { configOption, KahunConfigurationOptionType } from "../lib/annotations";
export class StandaloneOptions {

  @configOption({
    description: "Standalone: Show the patient's name in the patients table",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  showPatientName?: boolean;

  @configOption({
    description:
        "Standalone: Show cases creation date and time in the patients table",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  showCreationDate?: boolean;

  @configOption({
    description: "Standalone: Show visits date and time in the patients table",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  showVisitDate?: boolean;

  @configOption({
    description: "Standalone: Allow case creation from manual summary",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  manualCaseFromSummery?: boolean;

  @configOption({
    description: "Standalone: PII warning message",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  checkPIIWarning?: boolean;

  @configOption({
    description: "Show Assessment/Plan/DD in the patient card",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  showInsights?: boolean;

  @configOption({
    description: "Show Appointment Summary",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  showAppointmentSummary?: boolean;

  @configOption({
    description: "Appointment Summary Prompt",
    displayType: KahunConfigurationOptionType.Text,
  })
  appointmentSummaryPrompt?: string;
}